import { readRootFormFunctions } from '@/common/utils/formRootOnLoad'

function readFunctionsText(value: unknown): string {
  if (typeof value === 'string') {
    return value
  }
  if (value && typeof value === 'object' && '_text' in value) {
    const text = (value as { _text?: unknown })._text
    return typeof text === 'string' ? text : ''
  }
  return ''
}

/**
 * Common functions block for En.run — без literal "undefined" при пустом <functions/>.
 */
export function resolveFormFunctionsForEnRun(
  pageData: unknown,
  formId: number,
  pageDataSlotId: string,
): string {
  if (!pageData || typeof pageData !== 'object') {
    return ''
  }

  const root = pageData as Record<string, unknown>
  // Один page entry ({ form, uniData, ... }) — как после _setPageData(slot).
  const fromRoot = readRootFormFunctions(root)
  if (fromRoot) return fromRoot

  const rootForm = root.form
  if (rootForm && typeof rootForm === 'object' && !Array.isArray(rootForm)) {
    const fromForm =
      readRootFormFunctions(rootForm) ??
      readFunctionsText((rootForm as { functions?: unknown }).functions)
    if (fromForm) return fromForm
  }

  const keys: string[] = []
  const slot = pageDataSlotId.trim()
  if (slot) keys.push(slot)
  if (formId >= 0) {
    keys.push(String(formId))
  }

  for (const key of keys) {
    const page = root[key]
    if (!page || typeof page !== 'object') continue
    const text = readRootFormFunctions(page)
    if (text) return text
    const form = (page as { form?: unknown }).form
    if (!form || typeof form !== 'object' || Array.isArray(form)) continue
    const nested =
      readRootFormFunctions(form) ??
      readFunctionsText((form as { functions?: unknown }).functions)
    if (nested) return nested
  }

  return ''
}

export function scriptHasAsyncOperations(script: string): boolean {
  const withoutComments = script
    .replace(/\/\/[^\n\r]*/g, '')
    .replace(/\/\*[\s\S]*?\*\//g, '')
  return /await\s+|Promise\.|\.then\(/i.test(withoutComments)
}

/** Платформенные ключи document identity */
export const RELOAD_DOCUMENT_IDENTITY_KEYS = [
  '_id',
  '_typeId',
  '_versionId',
  '_typeVersionId',
  '_typeVersion',
] as const

export function pickDocumentIdentityFromSnapshot(
  snapshot: Record<string, unknown> | null | undefined,
): Record<string, unknown> {
  if (!snapshot || typeof snapshot !== 'object') return {}
  const out: Record<string, unknown> = {}
  for (const key of RELOAD_DOCUMENT_IDENTITY_KEYS) {
    if (Object.prototype.hasOwnProperty.call(snapshot, key)) {
      out[key] = snapshot[key]
    }
  }
  return out
}
